import { Component, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { MedicoService } from './../../shared/servicio/medico/medico.service';

import { FormBuilder } from '@angular/forms';
@Component({
  selector: 'app-logrosmedico',
  templateUrl: './logrosmedico.component.html',
  styleUrls: ['./logrosmedico.component.css'],
})
export class LogrosmedicoComponent implements OnInit {
  constructor(
    private _medico: MedicoService,
    private modalService: BsModalService,
    private formbuilder: FormBuilder
  ) {}

  logrosmedic: any = [];
  form;
  modalRef: BsModalRef;
  // formulaTabla: any = [];

  showLoading: boolean = true;
  page = 1;
  limit = 1;
  count = 0;
  config = {
    animated: true,
    class: 'modal-xl modal-dialog-centered',
    backdrop: true,
    ignoreBackdropClick: true,
  };
  ngOnInit() {
    this.showLoading = true;
    this.getLogroMedico();
  }

  getLogroMedico() {
    this._medico
      .getLogrosMedico(this.page)
      .toPromise()
      .then((data) => {
        console.log(data);

        this.limit = Math.ceil(data['count']);
        this.count = data['count'];
        this.logrosmedic = data['results'];
        this.showLoading = false;
      })
      .catch((error) => console.log(error));
  }

  pageChanged(p) {
    this.page = p.page;
    this.getLogroMedico();
  }
}
